"use client";

import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { getViewModeChrome } from "./view-mode-chrome";

/**
 * GenericError — "Refining approach" placeholder.
 *
 * Compact inline row with a spinner, tinted by session viewMode.
 */
export function GenericError({ viewMode }: { viewMode?: string } = {}) {
  const chrome = getViewModeChrome(viewMode);

  return (
    <motion.div
      initial={{ opacity: 0, y: 4, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      className="w-full"
    >
      <div className={`rounded-md border ${chrome.card} overflow-hidden`}>
        <div className="px-3 py-2 flex items-center gap-2.5 min-w-0">
          <Loader2
            className={`w-3.5 h-3.5 ${chrome.iconMuted} animate-spin shrink-0`}
            strokeWidth={2}
          />
          <span className={`text-[13px] font-medium ${chrome.text} truncate`}>
            Refining approach
          </span>
        </div>
      </div>
    </motion.div>
  );
}
